import { useState } from 'react';
import {
	createSuperProduct,
	updateSuperProduct,
} from '@/API/repositories/superProduct';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { SUPER_PRODUCT_MESSAGES } from '../../../constants/superProduct';

const useSuperProductForm = ({ superProduct, products, onSaved }) => {
	const isEdit = Boolean(superProduct);
	const [name, setName] = useState(superProduct?.name || '');
	const { makeRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();
	const {
		queryFunctions: { refetch },
	} = useCommonDataContext();

	const linkedProducts = isEdit
		? products
				.filter((product) => product.super_product === superProduct._id)
				.sort((left, right) => left.name.localeCompare(right.name))
		: [];

	const handleSubmit = async () => {
		const trimmedName = name.trim();
		setName(trimmedName);

		if (!trimmedName) {
			addMessage(SUPER_PRODUCT_MESSAGES.EMPTY_NAME, 'error');
			return;
		}

		const request = isEdit
			? updateSuperProduct.bind(null, superProduct._id, { name: trimmedName })
			: createSuperProduct.bind(null, { name: trimmedName });
		const response = await makeRequest(request);

		if (!response?.data) {
			const errorMessage = isEdit
				? SUPER_PRODUCT_MESSAGES.COULD_NOT_SAVE
				: SUPER_PRODUCT_MESSAGES.COULD_NOT_CREATE;
			addMessage(errorMessage, 'error');
			return;
		}

		addMessage(SUPER_PRODUCT_MESSAGES.SAVED, 'success');
		refetch();
		await onSaved();
	};

	return {
		name,
		setName,
		isEdit,
		linkedProducts,
		handleSubmit,
	};
};

export default useSuperProductForm;
